import './PremiumBadge.css';

interface Props {
  size?: 'sm' | 'md';
  className?: string;
}

export function PremiumBadge({ size = 'sm', className = '' }: Props) {
  return (
    <span className={`premium-badge premium-badge--${size} ${className}`} aria-label="Premium">
      PRO
    </span>
  );
}
